import { Box, styled } from '@mui/material';

import { Button } from 'theSource/components';

export const EnrollmentBannerContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#ffffff',
  boxShadow: '0px 1px 10px 0px #0000003D',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    height: 'auto',
  },
}));

export const BannerBodyContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  width: '70%',
  padding: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const ButtonStyled = styled(Button)({
  width: '140px',
  height: '40px',
  padding: '12px, 20px, 12px, 20px !important',
  borderRadius: '55px',
  border: '1px solid #3C548E',
});

export const ImageStyled = styled('img')(({ theme }) => ({
  width: '30%',
  maxHeight: '200px',
  padding: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    width: '40%',
  },
}));
